import { useLayoutEffect, type RefObject } from 'react'

export const useMtdsAppSticky = (stickyRef: RefObject<HTMLElement | null>) => {
  useLayoutEffect(() => {
    const sticky = stickyRef.current
    if (sticky == null) return

    // MTDS can keep stale sticky state when sidebars remount after SPA navigation.
    sticky.style.setProperty('--pos', 'sticky')
    sticky.style.setProperty('--top', '0px')
  }, [stickyRef])
}
